import styled from 'styled-components';

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 375px;
  margin: 20px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 24px 24px;
  ${({ customStyles }) => customStyles || ''};
`;

const AppContainer = ({ customStyles, children }) => (
  <StyledContainer customStyles={customStyles}>{children}</StyledContainer>
);

export default AppContainer;
